<template>
  <div class="news-item">
    <div
      class="left-wrap"
      @click="
        $router.push({
          name: 'NewsShow',
          params: { id: recommend[0].id },
          query: { recommend: $route.params.id, title: $route.query.title },
        })
      "
    >
      <img class="left-cover" :src="recommend[0].thumb_img" alt="" />
      <div class="left-bottom">
        <div class="news-title">{{ recommend[0].title }}</div>
      </div>
    </div>
    <div
      v-if="listLen == 2"
      class="right-wrap left-wrap"
      @click="
        $router.push({
          name: 'NewsShow',
          params: { id: recommend[1].id },
          query: { recommend: $route.params.id, title: $route.query.title },
        })
      "
    >
      <img class="left-cover" :src="recommend[1].thumb_img" alt="" />
      <div class="left-bottom">
        <div class="news-title">{{ recommend[1].title }}</div>
      </div>
    </div>
    <div v-else class="right-wraps">
      <div v-for="(item, index) in listLong" :key="index" class="right" @click="goDetail(item)">
        <div class="img-box">
          <img class="right-img" :src="item.thumb_img" alt="" />
        </div>
        <div class="right-content">
          <p class="right-title">{{ item.title }}</p>
          <div class="news-footer">
            <span>{{ item.created_at | tsFormat('yyyy/MM/dd hh:mm') }}</span>
          </div>
          <div class="news-description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewsRecommendItem',
  props: {
    recommend: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      listLong: [],
    };
  },
  computed: {
    listLen() {
      return this.recommend.length;
    },
  },
  created() {
    if (this.recommend.length >= 3) {
      this.listLong = [this.recommend[1], this.recommend[2]];
    }
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        name: 'NewsShow',
        params: { id: item.id },
        query: {
          recommend: this.$route.params.id,
          title: this.$route.query.title,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.right-wrap {
  margin-left: 23px;
}
.left-wrap {
  width: 588px;
  height: 392px;
  float: left;
  border-radius: 6px;
  overflow: hidden;
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
    .left-cover {
      transform: scale(1.1);
    }
  }
  .left-cover {
    width: 588px;
    height: 392px;
    border-radius: 6px;
    transform: scale(1);
    transition: 0.2s all;
  }
  .left-bottom {
    width: 588px;
    height: 48px;
    border-radius: 0px 0px 6px 6px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    bottom: 0;
    .news-title {
      // width: 240px;
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      text-align: LEFT;
      color: #ffffff;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 13px 22px;
      transition: 0.2s all;
    }
  }
}
.news-item {
  width: 1200px;
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin: 0 auto 32px;
  &:nth-child(2) {
    .wrap {
      margin-right: 0;
    }
  }
  &:nth-child(3) {
    .wrap {
      margin-right: 0;
    }
  }
  .right-wraps {
    margin-left: 24px;
    overflow: hidden;
    width: 588px;
    height: 392px;
    .right {
      width: 588px;
      height: 184px;
      background: #ffffff;
      border-radius: 6px;
      margin-bottom: 24px;
      &:hover {
        box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
        .right-img {
          transform: scale(1.1);
        }
        .right-content {
          .right-title {
            color: #f4242e;
          }
        }
      }
      .img-box {
        width: 276px;
        border-radius: 6px 0 0 6px;
        float: left;
        margin-right: 20px;
        height: 184px;
        overflow: hidden;
      }
      .right-img {
        width: 276px;
        height: 184px;
        border-radius: 6px 0 0 6px;
        transform: scale(1);
        transition: 0.2s all;
      }
      .right-content {
        position: relative;
        float: left;
        overflow: hidden;
        width: 272px;
        height: 184px;
        .right-title {
          width: 252px;
          // height: 44px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: LEFT;
          color: #333333;
          line-height: 22px;
          margin: 24px 0 8px 0;
        }
        .news-description {
          height: 48px;
          font-size: 16px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          transition: 0.2s all;
          width: 272px;
          height: 48px;
          font-size: 13px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: LEFT;
          color: #999999;
          line-height: 24px;
          position: absolute;
          bottom: 16px;
        }
        .news-footer {
          height: 22px;
          font-size: 14px;
          font-family: HarmonyOS Sans SC, HarmonyOS Sans SC-Regular;
          font-weight: 400;
          text-align: LEFT;
          color: #333333;
          line-height: 22px;
          transition: 0.2s all;
          .click-rate {
            margin-left: 14px;
          }
        }
      }
    }
  }
}
</style>
